module.exports = __webpack_public_path__ + "img/galery-smart-scan-1.69fcf958.png";